/* eslint-disable jsx-a11y/label-has-associated-control */
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import authenticationService from 'services/authentication/authentication-service';
import { ACCESS_TOKEN } from 'data/constants';

import "../styles/login.css"
import background from 'assets/icons/background.svg';

function LoginPage() {
  const [loggingIn, setLoggingIn] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const schema = yup.object().shape({
    id: yup.string()
        .required('필수 입력항목 입니다.'),
    password: yup.string()
        .required('필수 입력항목 입니다.')
  });

  const handleOnSubmit = async (values) => {
    let response = null;

    try {
      setLoggingIn(true);

      response = await authenticationService.login({
        id: values.id,
        password: values.password
      });
    } catch (e) {
      console.error(e);
    }

    setLoggingIn(false);

    if (response && response.status === 200 && response.access_token) {
      localStorage.setItem(ACCESS_TOKEN, response.access_token);
      navigate('/community/inquiry');
    } else {
      setErrorMsg((response && response.message) || '아이디 또는 비밀번호가 올바르지 않습니다.');
    }
  };
  
  const formik = useFormik({
    initialValues: {
      id: '',
      password: ''
    },
    validationSchema: schema,
    onSubmit: handleOnSubmit,
  });

  return (
    <div className="d-flex align-items-center py-4 bg-body-tertiary">
      <main className="form-signin w-100 m-auto">
        <form onSubmit={formik.handleSubmit}>
          <img className="mb-4" src={background} alt="" width="72" height="57" />
          <h1 className="h3 mb-3 fw-normal">Please log in</h1>

          <div className="form-floating">
            <input type="text" className={`form-control ${formik.errors.id ? 'is-invalid' : ''}`} name="id" id="floatingInput" placeholder="name@example.com" 
                value={formik.values.id} onChange={formik.handleChange}/>
            <label htmlFor="floatingInput">ID</label>
          </div>
          <div className="form-floating">
            <input type="password" className={`form-control ${formik.errors.password ? 'is-invalid' : ''}`} name="password" id="floatingPassword" placeholder="Password" 
                value={formik.values.password} onChange={formik.handleChange}/>
            <label htmlFor="floatingPassword">Password</label>
          </div>
          {errorMsg && <div className="alert alert-danger py-2" style={{ fontSize: 14 }}>{errorMsg}</div>}
          <button className="btn btn-primary w-100 py-2" type="button" disabled={!formik.isValid || loggingIn} onClick={() => {
            formik.submitForm();
          }}>
            {loggingIn ? '로그인 중...' : 'Log in'}
          </button>
          <p className="mt-5 mb-3 text-body-secondary">&copy; 2017–2023</p>
        </form>
      </main>
    </div>
  )
}

export default LoginPage;